import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { setUserSession } from './service/AuthService';

import './css/Login-Register.css';
import video1 from './assets/videos/11272939-uhd_2160_3840_25fps.mp4';
import video2 from './assets/videos/7063369-hd_1920_1080_24fps.mp4';
import video3 from './assets/videos/8231585-uhd_4096_2160_25fps.mp4';

import { MateriaBasicTextField, MaterialPassword } from './MaterialComponents';


//TODO: move this to an environment variable
const loginrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/login';
const resetRequestUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/resetpassrequest';
const loadingSpinner = document.querySelector('.donut');

const loginArrowIcon = (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
        <path
            d="M2.5 6.5h8M6.5 2.5l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);


const Login = () => {
    const videos = [video1, video2, video3];
    const prefersReducedMotion = typeof window !== 'undefined'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    //Learning Form Data (move it here)
    function handleUsernameState(newValue) {
        setUsername(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }

    const [message, setMessage] = useState('');
    const [resetMessage, setResetMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);
    const [loginExpanded, setLoginExpanded] = useState(false);
    const [showResetForm, setShowResetForm] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(0);
    const [fade, setFade] = useState(true);


    const navigate = useNavigate()

    const registerHandler = () => {
        //console.log('lets register woooo')
        // navigate('/register');
    }
    const joinHandler = () => {
        console.log('lets sign up woooo')
        navigate('/register');
    }

    const resetPasswordrHandler = () => {
        setShowResetForm(true);
        setResetMessage('');
    }

    const resetSubmitHandler = (event) => {
        event.preventDefault();
        if (username.trim() === '') {
            setResetMessage('Please enter your email.');
            return;
        }
        setResetMessage("If an account with that email exists, we've sent a password reset link. Please check your inbox.");

        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        };

        const requestBody = {
            username: username,
        };

        axios.post(resetRequestUrl, requestBody, requestConfig).catch((error) => {
            const status = error.response?.status;
            const serverMessage = error.response?.data?.message;
            if (status === 401 || status === 403) {
                setResetMessage(serverMessage || 'Unable to reset password right now.');
            } else {
                setResetMessage('Sorry the server is down. Please try again later.');
            }
        });
    };

    const submitHandler = (event) => {
        event.preventDefault();
        if(username.trim() === '' || password.trim() === ''){
            setMessage('Both username and password are required');
            return;
        }
        setMessage(null)
        setMessage('Logging in...')
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            password: password
        }



        axios.post(loginrUrl, requestBody, requestConfig).then((response) => {
            const { user } = response.data;
            const accessToken = response.data.accessToken ?? response.data.token;
            const refreshToken = response.data.refreshToken ?? response.data.refresh_token ?? '';
            if (!user || !accessToken) {
                setMessage('Invalid login response. Please try again.');
                return;
            }
            setUserSession(user, accessToken, refreshToken);
            if (!user.onboardingComplete) {
                navigate('/landing-form');
            } else {
                const headerEl = document.querySelector('.header');
                if (headerEl) headerEl.style.display = 'block';
                navigate('/daily-content');
            }
        }).catch((error) => {
            const status = error.response?.status;
            const serverMessage = error.response?.data?.message;
            if (status === 401 || status === 403) {
                setMessage(serverMessage || 'Invalid email or password.');
            } else {
                setMessage('Sorry the server is down. Please try again later.');
            }
        });
    }

    useEffect(() => {
        document.querySelector('.header').style.display = 'none'
        if (loadingSpinner) {
            //console.log('deleting donute')
            loadingSpinner.style.display = 'none'; // Example: Change the text color
        }
        const appElement = document.querySelector('.App');
        if (appElement) {
            appElement.style.background = '#000000';
            appElement.style.boxShadow = 'none';
            appElement.style.borderRadius = '0';
        }
        document.body.style.background = '#000000';
        document.body.style.color = '#FFFFFF';

        // Optional: Reset styles on unmount
        return () => {
        if (appElement) {
            appElement.style.background = '';
            appElement.style.boxShadow = '';
            appElement.style.borderRadius = '';
        }
        document.body.style.background = '';
        document.body.style.color = '';
        };
    }, []);

    useEffect(() => {
        const el = document.getElementById('login-root');
        if (el) el.classList.add('playing');
    }, []);

    useEffect(() => {
        if (!loginExpanded) {
            return undefined;
        }
        const prevBody = document.body.style.overflow;
        const prevHtml = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prevBody;
            document.documentElement.style.overflow = prevHtml;
        };
    }, [loginExpanded]);

    useEffect(() => {
        if (prefersReducedMotion) {
            return undefined;
        }

        let switchTimeout;
        const timer = setInterval(() => {
            setFade(false);

            switchTimeout = setTimeout(() => {
                setCurrentVideo((prev) => (prev + 1) % videos.length);
                setFade(true);
            }, 250);
        }, 7000);

        return () => {
            clearInterval(timer);
            if (switchTimeout) {
                clearTimeout(switchTimeout);
            }
        };
    }, [prefersReducedMotion, videos.length]);

    return (
    <div
        id="login-root"
        className={`auth-container${loginExpanded ? ' login-root--form-open' : ''}`}
        style={{ background: prefersReducedMotion ? '#0D1210' : '#000000' }}
    >
        {!prefersReducedMotion && (
            <div className="login-video-bg" aria-hidden="true">
                <video
                    key={currentVideo}
                    src={videos[currentVideo]}
                    autoPlay
                    muted
                    playsInline
                    loop={false}
                    className="login-video-element"
                    style={{ opacity: fade ? 1 : 0 }}
                />
            </div>
        )}
        <div className="login-video-overlay" aria-hidden="true" />
        <div className="login-video-grain" aria-hidden="true" />

        <div className="login-content-layer">
        <div className="login-inner">
            <div className="login-top">
                <h1 className="wordmark">Your Mental <br/>Wellness Gym</h1>
            </div>

            <div className="login-bottom">
                {!loginExpanded && (
                    <button
                        type="button"
                        className="homeBttn btn-login"
                        onClick={() => {
                            setShowResetForm(false);
                            setLoginExpanded(true);
                        }}
                    >
                        Login
                        {loginArrowIcon}
                    </button>
                )}

                {loginExpanded && (
                    <button
                        type="button"
                        className="login-form-back"
                        onClick={() => {
                            if (showResetForm) {
                                setShowResetForm(false);
                                setResetMessage('');
                            } else {
                                setLoginExpanded(false);
                            }
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                            <path
                                d="M11 7H3M7 3L3 7l4 4"
                                stroke="currentColor"
                                strokeWidth="1.0"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                )}

                <form
                    onSubmit={showResetForm ? resetSubmitHandler : submitHandler}
                    className={loginExpanded ? 'login-form login-form--open' : 'login-form'}
                >
                    <div className="login-form-stack">
                        <div className="login-form-main">
                            <div className="login-form-header">
                                <h4 className="form-title form-headline">
                                    {showResetForm ? 'Reset Password' : <>Your Home for <br/> Mental Wellness</>}
                                </h4>
                            </div>

                            {!showResetForm && (
                                <div className="login-form-fields">
                                    <div className="field-email login-field">
                                        <div className="relapseQuestion">email:</div>
                                        <MateriaBasicTextField handleChange={handleUsernameState}/>
                                    </div>
                                    <div className="field-password login-field">
                                        <div className="relapseQuestion">password:</div>
                                        <MaterialPassword handleChange={handlePasswordState} />
                                    </div>
                                    <div
                                        className="forgot"
                                        onClick={() => resetPasswordrHandler()}
                                    >
                                        Forgot your Password?
                                    </div>
                                </div>
                            )}

                            {showResetForm && (
                                <div className="login-form-fields login-form-fields--reset">
                                    <p className="reset-form-copy">Enter your email and we will send you a reset link.</p>
                                    <div className="field-email login-field">
                                        <div className="relapseQuestion">email:</div>
                                        <MateriaBasicTextField handleChange={handleUsernameState}/>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="login-form-footer">
                            {!showResetForm && message && <p className="message"> { message } </p>}
                            {showResetForm && resetMessage && <p className="message"> { resetMessage } </p>}
                            <button type="submit" className="homeBttn btn-login">
                                {showResetForm ? 'Reset Password' : 'Login'}
                                {loginArrowIcon}
                            </button>
                        </div>
                    </div>
                </form>

                {!loginExpanded && (
                    <button type="button" className="homeBttn btn-about" onClick={() => {window.open("https://trampolinehealth.co", "_blank");}}>About Trampoline</button>
                )}
            </div>
        </div>
        </div>
    </div>
);

}


export default Login;
